module.exports = __webpack_public_path__ + "img/menu_reminders.f5aa62f3.png";